// A background photo dimmed and faded into the page: lowered opacity, a dark
// scrim behind the text side and a gradient mask at the bottom, so text on
// top keeps AA contrast whatever the image looks like. `fade="soft"` keeps
// more of the picture showing behind the text (the home page hero).
import { cn } from '../../lib/format.js'

const SCRIMS = {
  left: 'bg-gradient-to-r from-page via-page/80 to-page/20 max-lg:bg-gradient-to-b max-lg:from-page/60 max-lg:via-page/85 max-lg:to-page',
  softLeft: 'bg-gradient-to-r from-page/75 via-page/45 to-page/20 max-lg:bg-gradient-to-b max-lg:from-page/55 max-lg:via-page/75 max-lg:to-page',
  top: 'bg-gradient-to-b from-page/30 via-page/60 to-page',
}

export function FadedPhoto({ src, position = 'center', alt = '', side = 'left', strength = 'normal', fade = 'normal', className }) {
  const soft = fade === 'soft'
  return (
    <div className={cn('absolute inset-0 overflow-hidden', className)}>
      <img
        src={src}
        alt={alt}
        decoding="async"
        style={{ objectPosition: position }}
        className={cn(
          'size-full object-cover saturate-[0.85] [mask-image:linear-gradient(to_bottom,black_45%,transparent)]',
          strength === 'subtle' ? 'opacity-40' : soft ? 'opacity-60' : 'opacity-50',
        )}
      />
      <div
        aria-hidden="true"
        className={cn('absolute inset-0', side === 'left' ? SCRIMS[soft ? 'softLeft' : 'left'] : SCRIMS.top)}
      />
    </div>
  )
}
